import React from 'react';

const TitleComponent = (props: any) => {
  return (
    <div>{props.username || 'User'}</div>
  );
}

export default TitleComponent;
